import { userComments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">用户热评</h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-5">
          {userComments.map((comment) => (
            <div
              key={comment.id}
              className="break-inside-avoid mb-4 md:mb-5 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <div className="flex items-center gap-0.5 flex-shrink-0">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-xs text-amber-400"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                "{comment.content}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}